import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { CanCreateAccountModule } from './can-create-account/can-create-account.module';
import { ContextDirectivesModule } from './context/context-directives.module';
import { GaEventDirective } from './ga-event/ga-event.directive';
import { ImgAssetModule } from './img-asset/img-asset.module';
import { PendoGuideStarterModule } from './pendo-guide-starter/pendo-guide-starter.module';
import { PrettyPhoneNumberDirective } from './pretty-phone-number/pretty-phone-number.directive';
import { SupportLinkModule } from './support-link/support-link.module';
import { CrossAppLinkModule } from './cross-app-link/cross-app-link.module';

@NgModule({
  declarations: [GaEventDirective, PrettyPhoneNumberDirective],
  exports: [
    CanCreateAccountModule,
    ContextDirectivesModule,
    GaEventDirective,
    ImgAssetModule,
    CrossAppLinkModule,
    PendoGuideStarterModule,
    PrettyPhoneNumberDirective,
    SupportLinkModule,
  ],
  imports: [
    ImgAssetModule,
    CommonModule,
    SupportLinkModule,
    PendoGuideStarterModule,
    ContextDirectivesModule,
  ],
})
export class DirectivesModule {}
